"use client"

import Link, { type LinkProps } from "next/link"
import { forwardRef, type AnchorHTMLAttributes, type ReactNode } from "react"
import { localizePath } from "@/shared/lib/i18n/config"
import { useCurrentLocale } from "@/shared/hooks/use-current-locale"

type LocalizedLinkProps = LinkProps &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps | "href"> & {
    children: ReactNode
  }

function isLocalHref(href: LinkProps["href"]): href is string {
  return typeof href === "string" && href.startsWith("/") && !href.startsWith("//")
}

export const LocalizedLink = forwardRef<HTMLAnchorElement, LocalizedLinkProps>(
  function LocalizedLink({ href, ...props }, ref) {
    const locale = useCurrentLocale()
    const localizedHref = isLocalHref(href) ? localizePath(href, locale) : href
    return <Link ref={ref} href={localizedHref} {...props} />
  }
)
